//
export default [
    {
        text: '#',
        value: 'id',
        sortable: true,
        width: '5%',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'Tipo',
        value: 'hr_asset_discount_type_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                small: true,
            },
        },
        width: '15%',
    },
]
